import config from '@config';

import { resourceWithPagination } from './utils';
import pagesRoutes from './pages';
import articlesRoutes from './articles';
import emailsRoutes from './emails';
import bookRoutes from './book';

// By default fake api in dev env is turned off
// Comment out routes which needs to be passed through
export default function routes() {
  this.urlPrefix = config.api.url;
  this.namespace = '/api/v1';

  pagesRoutes(this);

  articlesRoutes(this);

  emailsRoutes(this);

  bookRoutes(this);

  resourceWithPagination(this, { resource: 'competitions' });
  resourceWithPagination(this, { resource: 'events', paginatedSerializer: 'paginated-events' });
  resourceWithPagination(this, { resource: 'athletes', searchInKeys: ['firstName', 'lastName'] });
  resourceWithPagination(this, { resource: 'disciplines', searchInKeys: ['name'] });
  resourceWithPagination(this, { resource: 'documents', searchInKeys: ['title'] });

  this.resource('users');

  this.passthrough();
}
